import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { CalendarComponent } from './components/calendar/calendar.component';
import { SelectionBarComponent } from './components/selection-bar/selection-bar.component';
import { DayViewComponent } from './components/day-view/day-view.component';
import { MonthViewComponent } from './components/month-view/month-view.component';
import { YearViewComponent } from './components/year-view/year-view.component';

import { FarrisDatePickerDirective } from './farris-datepicker.input';
import { FarrisDatepickerComponent } from './farris-datepicker.component';
import { SelectionSidebarComponent } from './components/selection-sidebar/selection-sidebar.component';
import { AngularMyDatePickerComponent } from './AngularMyDatePicker.component';

import { TimePickerModule } from '@farris/ui-time-picker';
import { LocaleModule } from '@farris/ui-locale';
import { PopoverModule } from '@farris/ui-popover';
import { DateHelperModule } from '@farris/ui-common/date';
import { NotifyModule  } from '@farris/ui-notify';
import { FarrisCommonModule } from '@farris/ui-common';
import { FarrisFormsModule } from '@farris/ui-forms';

import { DynamicViewComponent } from './components/dynamic-view/dynamic-view.component';
import { DynamicDateInputComponent } from './dynamic-date-input/dynamic-date-input.component';
import { MultiSelectDateInputComponent } from './multi-date-input/multi-date-input.component';
import { MultiDayViewComponent } from './components/multi-day-view/multi-day-view.component';
import { MultiSelectedDaysComponent } from './components/multi-day-view/multi-days.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule, 
        TimePickerModule,
        LocaleModule,
        FarrisCommonModule,
        PopoverModule.forRoot(),
        DateHelperModule.forRoot(),
        NotifyModule.forRoot(),
        FarrisFormsModule
    ],
    declarations: [
        CalendarComponent,
        SelectionSidebarComponent,
        SelectionBarComponent,
        DayViewComponent,
        MonthViewComponent,
        YearViewComponent,
        FarrisDatepickerComponent,
        FarrisDatePickerDirective,
        AngularMyDatePickerComponent,
        DynamicViewComponent,
        DynamicDateInputComponent,
        MultiSelectDateInputComponent,
        MultiDayViewComponent,
        MultiSelectedDaysComponent
    ],
    entryComponents: [CalendarComponent],
    exports: [
        CalendarComponent,
        SelectionBarComponent,
        SelectionSidebarComponent,
        DayViewComponent,
        MonthViewComponent,
        YearViewComponent,
        FarrisDatepickerComponent,
        FarrisDatePickerDirective,
        DynamicViewComponent,
        DynamicDateInputComponent,
        MultiSelectDateInputComponent,
        MultiDayViewComponent,
        MultiSelectedDaysComponent
    ]
})
export class FarrisDatePickerModule {}
